<div class="w-100 h-100">
  <div class="theme-overlay-container">
    <div class="theme-overlay-header">
      <span class="theme-overlay-title" [translate]="'settings.auth.google_oauth'" ></span>
      <button
        type="button"
        [matTooltip]="'hint.message.common.close' | translate"
        mat-dialog-close
        class="close">
      </button>
    </div>

    <div class="theme-overlay-content">
      <form class="ts-form pt-30" [formGroup]="updateForm">
        <div class="form-group ts-form" >
          <label for="clientId" class="control-label required">
            <span [translate]="'Google Client ID'"></span>
          </label>
          <input
            type="text"
            formControlName="clientId"
            id="clientId" class="form-control">
          <span *ngIf="!updateForm.get('clientId').valid && updateForm.get('clientId').touched" class="help-block"
                [translate]="'Google Client ID'">
          </span>
        </div>

        <div class="form-group ts-form" >
          <label for="clientSecret" class="control-label required">
            <span [translate]="'Google Client Secret'"></span>
          </label>
          <input type="password"
                 formControlName="clientSecret"
                 id="clientSecret" class="form-control " >
          <span *ngIf="!updateForm.get('clientSecret').valid && updateForm.get('clientSecret').touched" class="help-block"
                [translate]="'Google Client Secret'">
          </span>
        </div>

      </form>
    </div>

    <div class="theme-overlay-footer">
      <button
        type="button"
        mat-dialog-close
        class="theme-btn-clear-default" [translate]="'btn.common.cancel'">
      </button>
      <button type="submit" [disabled]="!updateForm.valid"
              class="theme-btn-primary" (click)="onSubmit()"
              [translate]="saving? 'message.common.saving' : 'btn.common.save'"></button>
    </div>
  </div>
</div>
